<template>
  <div class="c-floating-avatar">
    <v-container class="pa-0">
      <v-flex align-center justify-center class="d-flex">
        <v-avatar
          :size="avatarSize"
          color="grey lighten-4"
          class="c-floating-avatar__overlap-block"
        >
          <img :src="imageSrc" alt="avatar" />
        </v-avatar>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "floating-avatar",
  props: {
    "avatar-size": {
      type: Number,
      default: 50,
    },
    "image-src": {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-floating-avatar {
  position: relative;
  .c-floating-avatar__overlap-block {
    position: absolute;
  }
}
</style>
